import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { find } from 'lodash';
import summaryTitle from 'lib/seats/summaryTitle';
import pricesForZone from 'lib/pricing/pricesForZone';
import { toCurrency } from 'lib/common/displayHelpers';

import { IconRemove, IconEye } from 'components/Icons';
import Price from 'components/Price';

class LineItem extends Component {
  constructor(props) {
    super(props);

    this.handlePriceTypeChange = this.handlePriceTypeChange.bind(this);
  }

  handlePriceTypeChange(event) {
    const prices = pricesForZone(
      this.props.prices,
      this.props.lineItem.seatData.zone_no
    );

    const priceData = find(prices, function(item) {
      return parseInt(item.price_type, 10) === parseInt(event.target.value, 10);
    });

    this.props.onChangeUpdatePrice(this.props.lineItem, priceData);
  }

  render() {
    const item = this.props.lineItem;
    const prices = pricesForZone(this.props.prices, item.seatData.zone_no);

    const showMultiplePriceTypes =
      this.props.onChangeUpdatePrice && prices.length > 1;

    return (
      <div
        className={classnames({
          'syos-lineitem': true,
          'syos-lineitem--multiple': showMultiplePriceTypes
        })}
      >
        <div className="syos-lineitem__details">
          {item.isLocked ? (
            <span className="syos-lineitem__title">
              {summaryTitle(item.seatData, this.props.zoneNames)}
            </span>
          ) : (
            <button
              className="syos-lineitem__title"
              onClick={this.props.onClickReselect}
              type="button"
              tabIndex={3}
            >
              <IconEye />
              {`${item.priceData.zone_desc} ${item.seatData.seat_row}-${
                item.seatData.seat_num
              }`}
            </button>
          )}
        </div>
        <div className="syos-lineitem__price">
          {showMultiplePriceTypes ? (
            <span className="syos-price-switch">
              <select
                className="syos-price-switch__select"
                onChange={this.handlePriceTypeChange}
                value={item.priceData.price_type}
                tabIndex={3}
              >
                <optgroup label="Change your price">
                  {prices.map(function(price, index) {
                    return (
                      <option key={index} value={price.price_type}>
                        {`${price.price_type_desc} ${toCurrency(price.price)}`}
                      </option>
                    );
                  })}
                </optgroup>
              </select>
            </span>
          ) : (
            <Price
              priceData={item.priceData}
              showDescription={prices.length > 1}
            />
          )}
          {!item.isLocked && (
            <button
              className="syos-lineitem__remove"
              type="button"
              onClick={this.props.onClickRemoval}
              aria-label="Remove this seat"
              tabIndex={3}
            >
              <IconRemove />
            </button>
          )}
        </div>
      </div>
    );
  }
}

LineItem.propTypes = {
  lineItem: PropTypes.object,
  prices: PropTypes.array,
  onClickRemoval: PropTypes.func,
  onClickReselect: PropTypes.func,
  onChangeUpdatePrice: PropTypes.func,
  zoneNames: PropTypes.object
};

export default LineItem;



// WEBPACK FOOTER //
// ./src/javascripts/components/LineItem.js